export default {
    namespaced: true,
    state() {
        return {
            headerMinimized: false,
            headerSection: null,
            headerPages: null,
            headerPagesHtml: null,
            headerButtonHtml: null,
        }
    },
    mutations: {
        setHeaderSection(state, section) {
            state.headerSection = section;
        },
        setHeaderPages(state, pages) {HeaderSetions
            state.headerPages = pages;
        },
        setHeaderPagesHtml(state, html) {
            state.headerPagesHtml = html;
        },
        setHeaderButtonHtml(state, html) {
            state.headerButtonHtml = html;
        },
        setHeaderMinimized(state, value) {
            state.headerMinimized = value;
        }
    }
}
